'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.FieldsetContextProvider = exports.FieldsetContextConsumer = exports.FieldsetContext = exports.defaultFieldsetContext = undefined;

var _react = require('react');

var defaultFieldsetContext = exports.defaultFieldsetContext = {
  disabled: false,
  size: 'default'
};

var FieldsetContext = exports.FieldsetContext = (0, _react.createContext)(defaultFieldsetContext);

var Consumer = FieldsetContext.Consumer,
    Provider = FieldsetContext.Provider;
exports.FieldsetContextConsumer = Consumer;
exports.FieldsetContextProvider = Provider;
exports.Consumer = Consumer; // Used downstream in FileManagerUI


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/context/FieldsetContext.js
// module id = 48
// module chunks = 177